import React from 'react'

const PL9 = (props) => {
    console.log(props)
    let tapBeers = props.tapMenu.sections[0].items
    let canBeers = props.canMenu.sections[0].items

    return (
        <div className="taps-can-page">
            <div className="background-image">
                <div className="col-left">
                    <div className="column pl9-taps-cans-pg-left">
                        {tapBeers.map(item => (
                            <div className="pl9-tap-item-page tap-item-print pl9">
                                    <div className="pl9-tap-item-name">{props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span></div>
                                    <div className="print-item-line-two-pl9">{item.containers[0].name} • <span className="style-print-pl9"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="col-right">
                    <div className="column pl9-taps-cans-pg-right">
                        {canBeers.map(item => (
                            <div className="pl9-tap-item-page cans tap-item-print">
                                    {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                    <div className="print-item-line-two-pl9">{item.containers[0].name} • <span className="style-print-can"> {item.style.replace("IPA - American", "IPA").replace("Lager - American Light", "Lager").replace('Lager - American', "Lager").replace("Wheat Beer - Witbier / Blanche", "Witbier").replace("Non - Alcoholic Beer", "N/A")}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PL9